import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm3.976-4.899c.27-.148.518-.34.756-.579.335-.337.527-.55.704-.797l.037-.044.025-.029c.201-.232.284-.368.299-.59.026-.36-.16-.632-.535-.98a3.763 3.763 0 0 0-.921-.612c-.11-.054-.17-.084-.232-.113a3.132 3.132 0 0 0-.67-.247c-.355-.08-.67-.043-.935.146-.114.08-.196.163-.339.326l-.037.041a3.41 3.41 0 0 1-.098.11 2.407 2.407 0 0 1-.603.474c-.979.522-2.322.306-3.154-.487a2.8 2.8 0 0 1-.752-1.942c.014-.565.2-1.119.529-1.554.092-.123.18-.22.374-.416l.021-.022.107-.109c.223-.233.335-.484.333-.793-.002-.29-.071-.509-.254-.93l-.041-.094c-.165-.383-.304-.647-.483-.89-.249-.337-.505-.578-.801-.701a.781.781 0 0 0-.539-.033c-.15.048-.244.113-.422.268l-.008.007-.068.058c-.74.567-1.21 1.067-1.486 1.69-.451 1.017-.356 2.216.15 3.469.46 1.141 1.229 2.23 2.191 3.154.53.553 1.151 1.06 1.822 1.492.944.607 1.918.997 2.873 1.106.776.088 1.525-.034 2.157-.379Z",
      clipRule: "evenodd"
    }
  )
);
var SvgCallCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallCircleFilled_default = SvgCallCircleFilled;

export { CallCircleFilled_default as default };
